<!--
 * @Descripttion:图表颜色配置
 * @Author: zenghua.wang
 * @Date: 2021-09-01 16:27:03
 * @LastEditors: zenghua.wang
 * @LastEditTime: 2021-12-10 11:21:42
-->
<template>
  <el-collapse-item :title="title">
    <!-- v-slot:prev -->
    <slot name="prev"></slot>

    <el-form-item
      label="颜色来源"
      v-if="selectColor"
    >
      <el-radio-group
        v-model="data.option.defaultColor"
        size="mini"
      >
        <el-radio-button :label="true">系统配色</el-radio-button>
        <el-radio-button :label="false">自定义配色</el-radio-button>
      </el-radio-group>
    </el-form-item>

    <el-form-item
      label="渐变色"
      v-if="showLinear"
    >
      <el-switch
        v-model="data.option.isLinear"
        :active-color="theme.active"
        :inactive-color="theme.inactive"
      />
    </el-form-item>

    <template v-if="showAction">
      <el-button
        type="primary"
        size="small"
        @click="addColor"
      >新增</el-button>

      <!-- 渐变色 -->
      <div
        style="margin: 10px 0"
        v-if="data.option.isLinear"
      >
        <el-table
          :data="data.option.colorList"
          v-loading="waitting"
          border
          size="small"
          style="width: 100%"
        >
          <el-table-column
            label="#"
            type="index"
            width="50"
            align="center"
          >
          </el-table-column>
          <el-table-column
            label="颜色1"
            width="80"
            align="center"
          >
            <template slot-scope="scope">
              <el-color-picker
                size="small"
                v-model="scope.row.color1"
                :show-alpha="theme.showAlpha"
                :predefine="predefineColors"
                @change="changeColor($event, scope.$index, 'color1')"
              />
            </template>
          </el-table-column>

          <el-table-column
            label="颜色2"
            width="80"
            align="center"
          >
            <template slot-scope="scope">
              <el-color-picker
                size="small"
                v-model="scope.row.color2"
                :show-alpha="theme.showAlpha"
                :predefine="predefineColors"
                @change="changeColor($event, scope.$index, 'color2')"
              />
            </template>
          </el-table-column>

          <el-table-column
            label="位置(max:100)"
            width="140"
            align="center"
          >
            <template slot-scope="scope">
              <el-input-number
                size="small"
                v-model="scope.row.position"
                :min="0"
                :max="100"
              />
            </template>
          </el-table-column>

          <el-table-column
            fixed="right"
            label="操作"
            width="100"
            align="center"
          >
            <template slot-scope="scope">
              <el-button
                type="text"
                size="small"
                icon="el-icon-top"
                @click="sortColor(scope.row, scope.$index, 'up')"
              ></el-button>
              <el-button
                type="text"
                size="small"
                icon="el-icon-bottom"
                @click="sortColor(scope.row, scope.$index, 'dowm')"
              ></el-button>
              <el-button
                type="text"
                size="small"
                icon="el-icon-delete"
                @click="deleteColor(scope.row, scope.$index)"
              ></el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!-- 纯色 -->
      <div
        style="margin: 10px 0"
        v-if="!data.option.isLinear"
      >
        <el-table
          :data="data.option.color"
          v-loading="waitting"
          border
          size="small"
          style="width: 100%"
        >
          <el-table-column
            label="#"
            type="index"
            width="50"
            align="center"
          >
          </el-table-column>
          <el-table-column
            label="颜色"
            width="100"
            align="center"
          >
            <template slot-scope="scope">
              <el-color-picker
                size="small"
                v-model="scope.row"
                :show-alpha="theme.showAlpha"
                :predefine="predefineColors"
                @change="changeColor($event, scope.$index)"
              />
            </template>
          </el-table-column>

          <el-table-column
            fixed="right"
            label="操作"
            width="140"
            align="center"
          >
            <template slot-scope="scope">
              <el-button
                type="text"
                size="small"
                icon="el-icon-top"
                @click="sortColor(scope.row, scope.$index, 'up')"
              ></el-button>
              <el-button
                type="text"
                size="small"
                icon="el-icon-bottom"
                @click="sortColor(scope.row, scope.$index, 'dowm')"
              ></el-button>
              <el-button
                type="text"
                size="small"
                icon="el-icon-delete"
                @click="deleteColor(scope.row, scope.$index)"
              ></el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </template>

    <el-form-item
      label="颜色循环"
      v-if="loopColor"
    >
      <el-switch
        v-model="data.option.loopColor"
        :active-color="theme.active"
        :inactive-color="theme.inactive"
      />
    </el-form-item>

    <!-- v-slot:extend -->
    <slot name="extend"></slot>
  </el-collapse-item>
</template>
<script>
import { predefineColors, theme } from '@/dragComponents/model/default.js'
import { isEmpty, getArray } from '@/dragComponents/utils'

export default {
  name: 'config-color',
  components: {},
  props: {
    title: {
      type: String,
      default: '颜色设置'
    },
    selectColor: {
      type: Boolean,
      default: true
    },
    loopColor: {
      type: Boolean,
      default: false
    },
    linearList: {
      type: Array,
      default: () => {
        return []
      }
    },
    data: {
      type: [Array, Object]
    }
  },
  data() {
    return {
      theme: theme,
      predefineColors: predefineColors,
      waitting: false
    }
  },
  computed: {
    showLinear() {
      if (this.selectColor) {
        let bool =
          !this.data.option.defaultColor &&
          this.linearList.includes(this.data.option.type)
        return bool
      } else {
        return this.linearList.includes(this.data.option.type)
      }
    },
    showAction() {
      if (this.selectColor) {
        return !this.data.option.defaultColor
      } else {
        return true
      }
    }
  },
  methods: {
    addColor() {
      let color = getArray(predefineColors, 1)
      if (this.data.option.isLinear) {
        if (isEmpty(this.data.option.colorList)) {
          this.$set(this.data.option, 'colorList', [])
        }
        this.data.option.colorList.push({
          color1: color[0],
          color2: '',
          position: 50
        })
      } else {
        this.data.option.color.push(color[0])
      }
    },
    sortColor(row, index, direction) {
      let list = this.data.option.isLinear
        ? this.data.option.colorList
        : this.data.option.color
      let len = list.length
      let stop = direction === 'up' ? 0 : len - 1
      if (index === stop) return
      let next = direction === 'up' ? index - 1 : index + 1
      this.waitting = true
      let temp = list[next]
      this.$set(list, index, temp)
      this.$set(list, next, row)
      setTimeout(() => {
        this.waitting = false
      }, 500)
    },
    deleteColor(row, index) {
      if (this.data.option.isLinear) {
        this.data.option.colorList.splice(index, 1)
      } else {
        this.data.option.color.splice(index, 1)
      }
    },
    changeColor(val, index, flag) {
      if (this.data.option.isLinear) {
        this.$set(this.data.option.colorList[index], flag, val)
      } else {
        this.$set(this.data.option.color, index, val)
      }
    }
  }
}
</script>
